import { render, staticRenderFns } from "./realImg.vue?vue&type=template&id=45cbcff3&scoped=true"
import script from "./realImg.vue?vue&type=script&lang=js"
export * from "./realImg.vue?vue&type=script&lang=js"
import style0 from "./realImg.vue?vue&type=style&index=0&id=45cbcff3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cbcff3",
  null
  
)

export default component.exports